import { ReminderConfirmDatasource } from '../datasources/create_reminder_datasource';
import { IQuery, IQueryMediator } from 'core-ts-types';
import { IReminderData } from '../personal_reminder_interface';

import * as _4 from 'lodash4';

export class ReminderQuery implements IQuery {
  private _result: IReminderData;

  constructor(QueryMediator: IQueryMediator, private reminderConfirmDatasource: ReminderConfirmDatasource) {
    QueryMediator.registerQuery(this, reminderConfirmDatasource);
  }

  run(): ReminderQuery {
    this._result = this.reminderConfirmDatasource.read();
    if (!_4.isEmpty(this._result.description)) {
      this._result.HTML_description = this._result.description.replace(/\n/g, '<br>');
    }
    return this;
  }

  get result() {
    return this._result;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/data-ng-personal-reminders/src/queries/reminder_query.ts